<template>
  <div class="card shadow p-3">
    <div class="card-header border-0 bg-transparent">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0 bg-transparent">
            {{ $t("advertising") }}
          </h3>
        </div>
      </div>
    </div>
    <b-row>
      <b-col md="2">
        <b-form-select
          v-if="
            !Array.isArray(tableData.data) || tableData.total === 0
              ? false
              : true
          "
          v-model="perPage"
          :options="[5, 10, 20, 100]"
          @input="changePerPage"
          size="sm"
          class="mt-2"
        ></b-form-select>
      </b-col>
      <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
        <b-form-group>
          <b-input-group>
            <b-form-input
              v-if="
                !Array.isArray(tableData.data) || tableData.data.length === 0
                  ? false
                  : true
              "
              class="form-control-sm"
              v-model="searchData"
              type="search"
              :placeholder="$t('search')"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          style="cursor: pointer"
          hover
          :items="tableData.data"
          :fields="columns"
          :per-page="tableData.per_page"
          :current-page="tableData.current_page"
          @row-clicked="openModal"
          :busy="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? true
              : false
          "
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(image)="data">
            <b-avatar
              :src="imageData(data.item.image)"
              size="3rem"
              rounded
              class="bg-transparent"
            ></b-avatar>
          </template>
          <template v-slot:cell(start_date)="data">
            <div>
              {{ moment(data.item.start_date).format("DD-MM-YYYY HH:mm") }} hrs.
            </div>
          </template>
          <template v-slot:cell(end_date)="data">
            <div>
              {{ moment(data.item.end_date).format("DD-MM-YYYY HH:mm") }} hrs.
            </div>
          </template>
          <template v-slot:cell(status)="data">
            <b-dropdown
              v-if="data.item.status_code == 1"
              size="sm"
              :text="data.item.status"
              class="table-text"
              :disabled="data.item.status_code == 2 ? true : false"
              variant="primary"
            >
              <b-dropdown-item-button
                class="table-text"
                v-for="item in typeStatus"
                :key="item.value"
                @click="approveAdvertising(data.item.id)"
                >{{ item.label }}</b-dropdown-item-button
              >
            </b-dropdown>
            <h2 v-else>
              <b-badge
                :class="
                  data.item.status_code == 5
                    ? 'bg-dark'
                    : data.item.status_code == 3
                    ? 'bg-info'
                    : 'bg-success'
                "
                >{{ data.item.status }}</b-badge
              >
            </h2>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              v-if="data.item.status_code == 3 || data.item.status_code == 4"
              variant="warning"
              size="sm"
              @click="
                pausePromotions({
                  promotion_id: data.item.id,
                  status: data.item.status_code == 3 ? 4 : 3,
                })
              "
              v-b-tooltip.hover
              :title="data.item.status_code == 3 ? $t('stop') : $t('play')"
              ><i
                :class="
                  data.item.status_code == 3
                    ? 'ri-pause-line'
                    : 'ri-play-mini-line'
                "
              ></i>
            </b-button>
          </template>
        </b-table>
        <b-pagination
          class="mt-3"
          v-model="tableData.current_page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
    <modal-create ref="create" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { myRendeImage } from "@/directives/render-Image";
import ModalCreate from "../AdvertisingService/modalCreate";
import moment from "moment";
import helpers from "@/services/helpers";

import _ from "lodash";
export default {
  name: "advertisingTable",
  mixins: [myRendeImage],
  components: {
    ModalCreate,
  },
  props: {
    type: {
      type: String,
    },
  },
  async created() {
    await this.fetchAdvertising({
      currentPage: this.currentPage,
      perPage: this.perPage,
    });
    this.debouncedGetAnswer = _.debounce(this.search, 300);
    this.statusText = this.tableData.status;
  },
  watch: {
    searchData: function (newQuestion, oldQuestion) {
      this.debouncedGetAnswer();
    },
  },
  data() {
    return {
      modalActive: false,
      dataAdvertising: {},
      perPage: 5,
      currentPage: 1,
      searchData: "",
      moment,
      statusText: "",
    };
  },
  methods: {
    async openModal(change) {
      this.$refs.create.showModal(change);
    },
    ...mapActions({
      fetchAdvertising: "advertising/fetchAdvertisingService",
      approve: "advertising/approveAdvertising",
      pausepromotion: "pausePromotion",
    }),
    async pausePromotions(data) {
      if (
        await helpers.showMsgConfirm({
          tittle: "are_you_sure?",
          msg: data.status == 4 ? "question_pause_promotion" : "question_play_promotion",
        })
      ) {
        const res = await this.pausepromotion(data);
        if (res.status === 200 || res.status === 201) {
          await this.search();
          this.$toast.success(res.message, {
            position: "top-right",
          });
        }
      }
    },
    async search() {
      await this.fetchAdvertising({
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.searchData,
      });
    },
    async changePage(value) {
      await this.fetchAdvertising({
        currentPage: value ? value : 1,
        perPage: this.perPage,
      });
    },
    async changePerPage() {
      await this.fetchAdvertising({
        currentPage: this.currentPage,
        perPage: this.perPage,
      });
    },
    async approveAdvertising(id) {
      const res = await this.approve({ promotion_id: id });
      if (res.status === 201) {
        this.$toast.success(res.message, {
          position: "top-right",
        });
      }
      this.fetchAdvertising({
        currentPage: this.currentPage,
        perPage: this.perPage,
      });
      // this.statusText = status;
    },
  },
  computed: {
    ...mapGetters({
      tableData: "advertising/getAdvertisingService",
    }),
    columns() {
      return [
        { label: "", key: "image", class: "text-center" },
        { label: this.$t("title"), key: "title", class: "text-center" },
        {
          label: this.$t("start-date"),
          key: "start_date",
          class: "text-center",
        },
        {
          label: this.$t("end-data"),
          key: "end_date",
          class: "text-center",
        },
        {
          label: this.$t("advertising_type"),
          key: "advertising_type.name",
          class: "text-center",
        },
        { label: this.$t("status"), key: "status", class: "text-center" },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
    textStatus() {
      return this.statusText;
    },
    colorStatus() {
      // let color;
      // switch (this.statusText.value) {
      //   case 1:
      //     color = 'warning'
      //     break;
      //   case 2:
      //     color = 'success'
      //     break;
      // }
      // return color
    },
    typeStatus() {
      return [{ value: 2, label: this.$t("approve") }];
    },
  },
};
</script>

